import { selectActiveType } from './selectActiveType';
import { IInfrastructureFeaturesMap } from '../../../common/types/infrastructure';
import { IMapState } from '../../types';

// стабильная ссылка: новый объект на каждый вызов заставлял подписчиков
// ре-рендериться на каждый диспатч
const EMPTY_FEATURES: IInfrastructureFeaturesMap = {};

export function selectActiveInfrastructureFeatures(state: IMapState): IInfrastructureFeaturesMap {
  const activeLayer = selectActiveType(state);

  if (!activeLayer) {
    return EMPTY_FEATURES;
  }

  const layerData = state.map.infrastructure.data[activeLayer.id];

  return layerData?.features || EMPTY_FEATURES;
}
